import { useEffect, useState } from "react";

// global
import { accountDataStore, companyStore, messageAndErrorStore, userStore } from "../../../store/Store";

// css and assets
import Close from "../../../assets/close.svg";

// hooks
import { useEscape } from "../../../hooks/useEscape";

export default function UpdateReceivedInvPopup({ inv, actionId, setTrigger }) {
  const JwtToken = userStore((data) => data.JwtToken);
  const currentUser = userStore((data) => data.currentUser);
  const setAccountReceivedInvoices = accountDataStore(
    (data) => data.setAccountReceivedInvoices
  );
  const setInvoiceCounts = companyStore((data) => data.setInvoiceCounts);
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)

  const [pending, setPending] = useState(false);
  const [title, setTitle] = useState(null);
  const [reqBody, setReqBody] = useState({
    id: inv.id,
    invoice_status_id: actionId,
    invoice_comments: "",
    updated_by_id: currentUser.id,
    is_asset: inv.is_asset,
    project_id: inv.project_id
  });

  useEffect(() => {
    if (inv) {
      switch (actionId) {
        case 29:
          setTitle(`Approve ${inv.invoice_name}`);
          break;
        case 30:
          setTitle(`Dispute ${inv.invoice_name}`);
          break;
        default:
          setTitle(null);
      }
    }
  }, [inv, setTitle, actionId]);

  useEscape(setTrigger);

  const handleClick = () => {
    setPending(true);
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);

    const requestOptions = {
      method: "PATCH",
      headers,
      body: JSON.stringify(reqBody),
      signal: controller.signal,
    };

    fetch(
      `${process.env.REACT_APP_BACKEND}/lc/account-vendor-invoice/${inv.id}`,
      requestOptions
    )
      .then((res) => {
        if (!res.ok) {
          toggleNewMessage(`${res.statusText} - ${res.status}`);
          setPending(false);
          return Promise.resolve();
        } else {
          return res.json();
        }
      })
      .then((data) => {
        if (!data) {
          setPending(false);
          return;
        } else {
          setAccountReceivedInvoices(data.vendor_invoices);
          setInvoiceCounts(data.invoice_counts)
          toggleNewMessage(null, "Invoice Updated");
          setPending(false);
          setTrigger(false);
        }
      })
      .catch((_) => {
        toggleNewMessage("Something went wrong");
        setPending(false);
        return;
      })
      .finally(() => setPending(false));
    return () => controller.abort();
  };

  return (
    inv && (
      <div className="popup">
        <div className="popup-inner-add-company">
          {!pending && (
            <img src={Close} onClick={() => setTrigger(false)} alt="close" />
          )}
          {title && <p>{title}?</p>}
          {actionId === 30 && (
            <textarea
              required={true}
              type="text"
              name="invoice_comments"
              title="Comments"
              placeholder="Comments"
              onChange={(e) =>
                setReqBody({ ...reqBody, invoice_comments: e.target.value })
              }
              value={reqBody.invoice_comments}
            />
          )}
          {!pending && (
            <button className="propx-btn" onClick={handleClick}>
              Yes
            </button>
          )}
          {!pending && (
            <button className="delete-btn" onClick={() => setTrigger(false)}>
              No
            </button>
          )}
          {pending && (
            <button
              className="btn btn-secondary"
              style={{ margin: "20px 20px 20px 0" }}
              disabled
            >
              Submitting...
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </button>
          )}
        </div>
      </div>
    )
  );
}
